(() => {
  function initialise(root) {
    if (root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const cards = Array.from(root.querySelectorAll('[data-preview-title]'));
    const grid = root.querySelector('[data-preview-grid]');
    if (!grid) return;
    const search = root.querySelector('[data-preview-search]');
    const sort = root.querySelector('[data-preview-sort]');
    const previous = root.querySelector('[data-preview-prev]');
    const next = root.querySelector('[data-preview-next]');
    const normalise = value => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    const titles = new Map(cards.map(card => [card, normalise(card.dataset.previewTitle)]));
    let page = 1;
    const size = 24;
    function readUrl() {
      const params = new URL(location.href).searchParams;
      search.value = params.get('q') || '';
      sort.value = params.get('sort') === 'az' ? 'az' : 'newest';
      page = Math.max(1, Number.parseInt(params.get('page'), 10) || 1);
    }
    function render(updateUrl = false) {
      const terms = normalise(search.value).split(' ').filter(Boolean);
      const matched = cards.filter(card => terms.every(term => titles.get(card).includes(term)));
      if (sort.value === 'az') matched.sort((a, b) => a.dataset.previewTitle.localeCompare(b.dataset.previewTitle, undefined, {numeric: true}));
      const pages = Math.max(1, Math.ceil(matched.length / size));
      page = Math.min(page, pages);
      // Detach off-page cards so their images do not load. Keep the complete list in memory for search.
      grid.replaceChildren(...matched.slice((page - 1) * size, page * size));
      root.querySelector('[data-preview-empty]').hidden = matched.length !== 0;
      root.querySelector('[data-preview-status]').textContent = matched.length
        ? `${(page - 1) * size + 1}–${Math.min(page * size, matched.length)} of ${matched.length} previews`
        : '0 previews';
      root.querySelector('[data-preview-page]').textContent = `Page ${page} of ${pages}`;
      root.querySelector('[data-preview-pagination]').hidden = pages <= 1;
      previous.disabled = page === 1;
      next.disabled = page === pages;
      if (updateUrl) {
        const url = new URL(location.href);
        for (const [key, value] of [['q', search.value.trim()], ['sort', sort.value === 'az' ? 'az' : ''], ['page', page > 1 ? String(page) : '']]) {
          if (value) url.searchParams.set(key, value); else url.searchParams.delete(key);
        }
        history.replaceState(null, '', url);
      }
    }
    search.addEventListener('input', () => { page = 1; render(true); });
    sort.addEventListener('change', () => { page = 1; render(true); });
    function changePage(delta) {
      page += delta;
      render(true);
      // Focus a stable element when a pagination button becomes disabled.
      search.focus({preventScroll: true});
      root.querySelector('[data-preview-tools]').scrollIntoView({block: 'start'});
    }
    previous.addEventListener('click', () => changePage(-1));
    next.addEventListener('click', () => changePage(1));
    window.addEventListener('popstate', () => { readUrl(); render(); });
    root.querySelector('[data-preview-tools]').hidden = false;
    readUrl(); render();
  }
  document.querySelectorAll('[data-comic-previews]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-comic-previews]').forEach(initialise));
})();
